import { render } from "./Delivery.vue?vue&type=template&id=56d2824f&scoped=true"
import script from "./Delivery.vue?vue&type=script&lang=js"
export * from "./Delivery.vue?vue&type=script&lang=js"

import "./Delivery.vue?vue&type=style&index=0&id=56d2824f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56d2824f"]])

export default __exports__